// Shoppable-video playback is owned by sections/shoppable-video.liquid
// (IntersectionObserver + Slick `afterChange` play ONLY the centered slide).
// The previous block here force-played EVERY shoppable video on load, which
// fought that per-slide logic and made all videos play at once — removed.

// ── jQuery readiness guard ───────────────────────────────────────────────────
// THE bug behind the dead shoppable-video carousel on iOS.
//
// jQuery is loaded `async`, so it is a race whether it has executed by the time
// this deferred file runs — a race it loses regularly on mobile Safari over
// cellular. This file calls jQuery at the TOP LEVEL in several places; the first
// such call then throws ReferenceError, and the browser abandons the entire rest
// of the file. Everything below that line — every widget, including the carousel
// boot — silently never runs. Nothing in the console points at the carousel;
// it just isn't there.
//
// So: never touch jQuery at the top level. Queue through the layout's onJQuery()
// (theme.liquid), with a local poll as a fallback so this file still behaves if
// it is ever loaded under a layout that lacks the helper.
function whenJQueryReady(cb) {
  if (typeof window.onJQuery === "function") {
    window.onJQuery(cb);
    return;
  }
  (function poll(tries) {
    if (window.jQuery) {
      try {
        cb(window.jQuery);
      } catch (err) {
        console.error("[custom.js]", err);
      }
      return;
    }
    if (tries > 400) {
      console.warn("[custom.js] jQuery never loaded; skipping jQuery widgets.");
      return;
    }
    setTimeout(function () {
      poll(tries + 1);
    }, 50);
  })(0);
}

// ── Drawer toggle fix (theme wide) ────────────────────────────────────────────
// Every drawer in this theme moves itself to <body> on open and back into its
// section on close (Drawer.shouldAppendToBody in theme.js). Each move runs
// disconnectedCallback/connectedCallback, which rebinds the drawer's click
// Delegate and tears down its FocusTrap. Once that state goes stale a single tap
// on a trigger toggles more than once — the menu drawer opens several times over
// and has to be closed as many times.
//
// Handling the toggle here, in the capture phase, keeps one tap to one toggle for
// every drawer: cart, search, the mobile menu, and any drawer a section adds.
// The behaviour is identical to theme.js's _onToggleClicked, which is defined
// once and never overridden, so nothing else about the drawers changes.
(function () {
  "use strict";

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest && e.target.closest("[aria-controls]");
      if (!trigger) return;

      var el = document.getElementById(trigger.getAttribute("aria-controls"));

      // Dialogs only. Tabs and accordions use aria-controls too and must keep
      // their own behaviour — DialogElement is the only thing that sets
      // role="dialog" on itself, so it is a reliable marker.
      if (
        !el ||
        el.getAttribute("role") !== "dialog" ||
        typeof el.show !== "function" ||
        typeof el.hide !== "function"
      ) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      if (el.hasAttribute("open")) {
        el.hide();
      } else {
        el.show();
      }
    },
    true,
  );
})();

// ── Cart drawer fixes ─────────────────────────────────────────────────────────
// Fixes three interrelated bugs where the cart drawer would silently close and
// then require multiple clicks to re-open (on both desktop and mobile).
//
// Root cause: theme.js's _onCartChanged dispatches cart:refresh → _onCartRefresh
// does a full replaceChildren on the open drawer → the focused element is
// destroyed → the FocusTrap deactivates → its onDeactivate calls hide() →
// drawer closes silently. The stale FocusTrap's document-level click interceptors
// persist after deactivation, blocking subsequent clicks from reaching the
// theme's Delegate handler.
//
// Fix 1: moved out into the theme wide drawer toggle fix above — it now covers
//         the cart icon and every other drawer trigger, resolved per click.
// Fix 2: Skip _onCartRefresh while drawer is open — _onCartChanged already
//         updates content, so the redundant full refresh is suppressed.
// Fix 3: Re-focus drawer after content mutations — keeps FocusTrap alive when
//         _onCartChanged's partial updates remove the focused element.
(function () {
  "use strict";

  function applyCartDrawerFixes() {
    var el =
      document.getElementById("cart-drawer") ||
      document.querySelector("cart-drawer");
    if (!el) return false;

    // Fix 2: Skip _onCartRefresh while drawer is open.
    if (typeof el._onCartRefresh === "function") {
      var origCartRefresh = el._onCartRefresh.bind(el);
      el._onCartRefresh = function () {
        if (el.hasAttribute("open")) return;
        return origCartRefresh();
      };
      if (el._onCartRefreshListener) {
        document.removeEventListener("cart:refresh", el._onCartRefreshListener);
        el._onCartRefreshListener = el._onCartRefresh.bind(el);
        document.addEventListener("cart:refresh", el._onCartRefreshListener);
      }
    }

    // Fix 3: Re-focus drawer after content mutations to keep FocusTrap alive.
    var contentMO = new MutationObserver(function () {
      if (!el.hasAttribute("open")) return;
      var active = document.activeElement;
      if (
        !active ||
        active === document.body ||
        active === document.documentElement ||
        !el.contains(active)
      ) {
        el.focus({ preventScroll: true });
      }
    });
    contentMO.observe(el, { childList: true, subtree: true });

    return true;
  }

  function tryApply(tries) {
    if (applyCartDrawerFixes()) return;
    if (tries > 50) return;
    setTimeout(function () {
      tryApply((tries || 0) + 1);
    }, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      tryApply(0);
    });
  } else {
    tryApply(0);
  }
})();

// Both scroll handlers below used to dereference querySelector() results
// unguarded, throwing on every single scroll event on any page/template where
// the element is absent. Null-check instead.
window.addEventListener("scroll", function () {
  const wrapper = document.querySelector(".header__wrapper");
  if (!wrapper) return;
  wrapper.classList.toggle("newClass", window.scrollY > 50);
});

document.addEventListener("DOMContentLoaded", function () {
  const headerObserver = document.querySelector("height-observer");
  if (!headerObserver) return;

  window.addEventListener("scroll", function () {
    headerObserver.classList.toggle("box-shadow", window.scrollY > 0);
  });
});

(function () {
  const revealImages = () => {
    document.querySelectorAll(".image-animate-reveal").forEach((img) => {
      if (img.complete) img.classList.add("is-loaded");
    });
  };
  // Run on initial load
  window.addEventListener("load", revealImages);
  // Run when Shopify Theme Editor updates a section
  document.addEventListener("shopify:section:load", revealImages);
})();

// _onVariantChanged(event) {
//   const variant = event.detail.variant;
//   this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
//   this.classList.toggle("text-on-sale", variant["compare_at_price"] > variant["price"]);

//   var elements = document.querySelectorAll(".product_price_info_1.saving-amt");

//   if (variant["compare_at_price"] > variant["price"]) {
//     elements.forEach(function (element) {
//        element.innerHTML = "You’ll save "+ formatMoney(variant["compare_at_price"] - variant["price"], currencyFormat);
//       element.style.display = "block";
//     });
//   } else {
//     elements.forEach(function (element) {
//       element.style.display = "none";
//     });
//   }

// }
whenJQueryReady(function () {
  jQuery(document).ready(function () {
    setTimeout(function () {
      jQuery(".popup-main-christmas").fadeIn();
    }, 5000);
    jQuery(
      ".popup-main-christmas .close-popup-christmas, .popup-christmas-body .btn-popup-christmas",
    ).click(function (e) {
      e.preventDefault();
      jQuery(".popup-main-christmas").fadeOut();
    });

    jQuery(document).on("click", ".back-icon-main-new-nav", function (e) {
      // remove attribute open from drawer
      jQuery(this).parent().css({
        transform: "translateX(500px)",
      });
      jQuery(this).parent().parent().find("summary .accordion__toggle").click();
      // setTimeout(() => {
      //   jQuery(
      //     '.ct-accordion-level-2-details[aria-expanded="true"] summary .accordion__toggle'
      //   ).click();
      // }, 500);
    });
  });

  // Delegated so it still binds when the rewards widget renders late.
  jQuery(document).on("click", ".rewards_link", function (e) {
    e.preventDefault();
    jQuery(".shopflow-rewards").click();
  });
});

async function cartRefresh2() {
  var response = await fetch("/cart.js");
  var cartContent = await response.json();

  const cartCount = cartContent.item_count || cartContent.total_items || 0; // Fallback to 0 if fields are missing
  const countBubble = document.querySelector(
    ".header__secondary-nav .count-bubble",
  );

  // Update the bubble only if it exists
  if (countBubble) {
    countBubble.textContent = cartCount;
  }

  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cartContent,
        replacementDelay: 750,
      },
    }),
  );

  // after cart refresh:event is dispatched, you can listen for it and do something

  return cartContent;
}

document.documentElement.addEventListener("cart:refresh", function (event) {
  // The theme dispatches a DETAIL-LESS `cart:refresh` (no event.detail) at the
  // end of CartDrawer._onCartChanged, which fires on every native cart change.
  // Reading event.detail.* unguarded threw "Cannot read properties of null
  // (reading 'replacementDelay')" on each one. Guard it: when there's no cart in
  // the detail, fall back to a server fetch so the bubble still updates.
  var detail = event.detail;
  var delay =
    detail && detail.replacementDelay != null ? detail.replacementDelay : 0;
  var cart = detail && detail.cart;

  // Plain DOM rather than jQuery: the cart bubble must stay correct even if
  // jQuery is unavailable.
  function paintBubble(count) {
    document
      .querySelectorAll(".header__secondary-nav .count-bubble")
      .forEach(function (el) {
        el.textContent = count;
        el.style.opacity = "1";
      });
  }

  setTimeout(function () {
    if (cart && cart.item_count != null) {
      paintBubble(cart.item_count);
      return;
    }
    fetch("/cart.js", { cache: "no-store" })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        paintBubble(c.item_count);
      })
      .catch(function () {});
  }, delay);
});

whenJQueryReady(function ($) {
  $(document).ready(function () {
    $(document).on("click", ".tab-main-list-bas li", function (e) {
      // remove active class from all li
      $(".tab-main-list-bas li").removeClass("active");

      // add active class to clicked li
      $(this).addClass("active");
      // get the data-tab attribute of clicked li
      var tabId = $(this).data("id");

      $(".bas-tab-item").hide();
      $(".bas-tab-item." + tabId).show();
    });

    $("body.template-page.better-aging-serum .product-info__description").each(
      function () {
        var $pTag = $(this).find("p").first(); // Just the first <p>
        var fullText = $pTag.text();

        if (fullText.length > 150) {
          var shortText = fullText.substring(0, 150) + "...";

          // Store full text in a data attribute for later use
          $pTag.addClass("full-text").hide(); // hide full text

          // Add preview text with "Read More"
          var previewHtml = `
        <p class="preview-text">
          ${shortText} <a href="#" class="read-more-link">Read More</a>
        </p>
      `;

          // Add "Read Less" inside the full text block
          var fullHtml = `
        <p class="full-text">
          ${fullText} <a href="#" class="read-less-link">Read Less</a>
        </p>
      `;

          // Replace the original <p> with new elements
          $(this).empty().append(previewHtml).append(fullHtml);
          $(this).find(".full-text").hide();
        }
      },
    );

    // Show full text
    $(document).on("click", ".read-more-link", function (e) {
      e.preventDefault();
      const $container = $(this).closest(".product-info__description");
      $container.find(".preview-text").hide();
      $container.find(".full-text").show();
    });

    // Show preview text
    $(document).on("click", ".read-less-link", function (e) {
      e.preventDefault();
      const $container = $(this).closest(".product-info__description");
      $container.find(".full-text").hide();
      $container.find(".preview-text").show();
    });
  });
}); // whenJQueryReady

// The shoppable slider boots from its OWN entry point at the bottom of this
// file, not from inside the $(document).ready block above — anything that
// throws in that block used to take the carousel down with it.

// ── Shoppable video slider (reusable, editor-aware) ──────────────────────────
// Slick only engages its infinite/centerMode loop when slideCount > slidesToShow.
// Cards per view is fixed by the design (7 across on desktop), so a section with
// fewer videos than that has to be padded out with clones before it can wrap at
// all — the merchant should never have to add more videos to get a working loop.
// Videos are preload="none", so the extra <video> tags cost nothing until the
// centered slide plays, but they are not free on iOS, which caps how many media
// elements one page may hold; hence the ceilings below.
function setupShoppableSlider($slider) {
  if (!$slider || !$slider.length) return;
  if ($slider.hasClass("slick-initialized")) return;

  var $items = $slider.children(".card-item");
  var originalCount = $items.length;
  if (originalCount === 0) return;

  var DESKTOP_SHOW = 7;

  // How many cards are on screen at once is FIXED per breakpoint — 7 across on
  // desktop whatever the merchant supplied. The card size is a design decision,
  // not something to derive from the block count: sizing the row to the content
  // blew four videos up into four oversized cards clipped by the section edges.
  // Too few videos to fill that row is solved by cloning, below, never by
  // showing fewer/larger cards.
  //
  // Clone until there are enough cards to wrap. The old condition here was
  // `originalCount > 1`, which is exactly why a single video was broken: it got
  // no clones, so slideCount === slidesToShow, so infinite and arrows both went
  // off and the card sat there unswipeable. Every count ≥ 1 gets padded now.
  //
  // Clone in WHOLE SETS. Padding 2 videos out to 3 cards gives A B A, which wraps
  // straight back onto A — the same clip twice in a row at the seam. A whole
  // number of sets can never do that, wherever the loop happens to be.
  //
  // maxCards is the iOS ceiling, and the reason the target is viewport-aware:
  // inflating to 15 cards on a phone too, on top of the extra slides slick itself
  // clones for infinite mode, pushed it past its media-element limit and the
  // videos stopped loading. A phone shows one slide, so 3 cards already look
  // infinite there.
  var isNarrow = window.matchMedia("(max-width: 575px)").matches;
  if (originalCount <= DESKTOP_SHOW) {
    var minCards = isNarrow ? 3 : DESKTOP_SHOW * 2 + 1; // 15 on desktop
    var maxCards = isNarrow ? 6 : 16; // whole sets can overshoot 15 by one
    var sets = Math.ceil(minCards / originalCount);
    while (sets * originalCount > maxCards && sets > 2) sets--;
    var target = sets * originalCount;
    var i = 0;
    while ($slider.children(".card-item").length < target) {
      var $clone = $items
        .eq(i % originalCount)
        .clone(true, true)
        .addClass("is-loop-clone");
      // Don't let cloned videos auto-play; the section plays only the centered one.
      $clone
        .find("native-video[autoplay], video[autoplay]")
        .removeAttr("autoplay");
      $slider.append($clone);
      if (++i > 300) break; // safety guard
    }
  }

  var total = $slider.children(".card-item").length;
  // total - 1 is the ceiling, not total: at slidesToShow === slideCount slick
  // switches the loop off. Only the 3-card mobile strip can reach it, and only
  // when that phone is turned landscape into a wider breakpoint.
  var cap = function (v) {
    return Math.max(1, Math.min(v, total - 1));
  };

  var options = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: cap(DESKTOP_SHOW),
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    centerMode: true,
    centerPadding: "0",
    prevArrow:
      '<button is="prev-button" class="circle-button circle-button--lg circle-button--fill border group"><span class="sr-only">Previous</span><span class="animated-arrow animated-arrow--reverse"></span></button>',
    nextArrow:
      '<button is="next-button" class="circle-button circle-button--lg circle-button--fill border group" ><span class="sr-only">Next</span><span class="animated-arrow"></span></button>',
    responsive: [
      {
        breakpoint: 1480,
        settings: { slidesToShow: cap(5), slidesToScroll: 1, arrows: true },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: cap(4), slidesToScroll: 1, arrows: true },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: cap(3), slidesToScroll: 1, arrows: true },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "15%",
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };

  try {
    $slider.slick(options);
  } catch (err) {
    console.error("[shoppable-video] slick init failed", err);
    markShoppableFallback($slider[0]);
    return;
  }

  $slider.removeClass("shoppable-no-slick");
  $slider[0].dispatchEvent(
    new CustomEvent("shoppable:slider-ready", { bubbles: true }),
  );
}

// Degrade to a plain swipeable row. The section stylesheet already renders any
// strip without .slick-initialized as a native horizontal scroller; this class
// marks that state as final rather than still-loading (it drops the snap-scroll
// animation and shows the scrollbar as an affordance), and the event lets the
// section's playback script re-evaluate which video should be playing.
function markShoppableFallback(slider) {
  if (!slider || slider.classList.contains("slick-initialized")) return;
  slider.classList.add("shoppable-no-slick");
  slider.dispatchEvent(
    new CustomEvent("shoppable:slider-fallback", { bubbles: true }),
  );
}

// Init every shoppable slider inside `scope` (defaults to the whole document).
function initShoppableSlidersIn(scope) {
  jQuery(scope || document)
    .find(".Shoppable-video-slider")
    .addBack(".Shoppable-video-slider")
    .each(function () {
      setupShoppableSlider(jQuery(this));
    });
}

// ── Making slick actually available ──────────────────────────────────────────
// This used to only WAIT for slick, and on the live site it waited forever:
// "[shoppable-video] slick never loaded; staying on scroll fallback."
// theme.liquid injects slick only once jQuery has executed, which is the right
// order but not a guarantee — three things leave jQuery.fn.slick permanently
// undefined no matter how long you poll, and all of them come from scripts this
// theme does not control:
//
//   1. slick ships a UMD wrapper: `define.amd ? define([...]) : exports ?
//      module.exports = factory(require("jquery")) : factory(jQuery)`. Any app
//      that puts an AMD loader or a stray `exports` on the page sends slick down
//      a branch that never registers the plugin (the CommonJS one additionally
//      throws on the missing `require`).
//   2. an app that loads its OWN jQuery afterwards replaces window.jQuery, and
//      the replacement has no .slick on it.
//   3. theme.liquid's injection never runs, because jQuery itself was blocked.
//
// So load it ourselves, forcing the browser-global branch. The URLs come from
// window.ShoppableSliderAssets, which sections/shoppable-video.liquid sets — a
// file in /assets cannot resolve `asset_url` on its own.
function hasSlick() {
  return !!(window.jQuery && jQuery.fn && jQuery.fn.slick);
}

// Run a UMD script down its `factory(window.jQuery)` branch by hiding the module
// globals for exactly as long as it takes to execute. The script body runs
// synchronously immediately before its own load event, so restoring there is the
// earliest possible moment; and theme.liquid already `<link rel=preload>`s both
// files, so by the time we inject one it is served from cache and that window is
// a few milliseconds, not a network round trip.
function loadGlobalScript(src, done) {
  if (!src) {
    done(false);
    return;
  }
  var hidden = ["define", "module", "exports"].map(function (key) {
    return { key: key, had: key in window, value: window[key] };
  });
  hidden.forEach(function (slot) {
    try {
      window[slot.key] = undefined;
    } catch (err) {}
  });
  function restore() {
    hidden.forEach(function (slot) {
      try {
        if (slot.had) window[slot.key] = slot.value;
        else delete window[slot.key];
      } catch (err) {}
    });
  }
  var el = document.createElement("script");
  el.src = src;
  el.async = false;
  el.onload = function () {
    restore();
    done(true);
  };
  el.onerror = function () {
    restore();
    done(false);
  };
  document.head.appendChild(el);
}

// `allowJQueryLoad` is held back on the first attempt: theme.liquid's jQuery tag
// is `async`, so a copy may still be in flight, and a second one landing after
// ours would replace window.jQuery and take our freshly-attached .slick with it.
// By the time we do allow it (~7s) that tag has long since resolved or failed.
var slickLoadInFlight = false;
function ensureSlick(allowJQueryLoad, done) {
  if (hasSlick()) {
    done(true);
    return;
  }
  if (slickLoadInFlight) {
    done(false);
    return;
  }
  var assets = window.ShoppableSliderAssets || {};
  slickLoadInFlight = true;

  function finish(ok) {
    slickLoadInFlight = false;
    done(ok);
  }
  function loadSlick() {
    if (hasSlick()) {
      finish(true);
      return;
    }
    if (!assets.slick) {
      finish(false);
      return;
    }
    loadGlobalScript(assets.slick, function () {
      finish(hasSlick());
    });
  }

  if (window.jQuery) {
    loadSlick();
    return;
  }
  if (!allowJQueryLoad || !assets.jquery) {
    finish(false);
    return;
  }
  loadGlobalScript(assets.jquery, function (ok) {
    if (!ok || !window.jQuery) {
      finish(false);
      return;
    }
    loadSlick();
  });
}

// Poll for slick, loading it ourselves at the marks below, and hand the section
// its scroll fallback in the meantime so the cards stay usable either way.
// Polling continues past the fallback, so slick arriving late — ours or the
// theme's — still upgrades the strip into a real carousel.
function whenSlickReady(cb, onDegrade) {
  var LOAD_AT = 20; // ~2s  — theme.liquid's own injection has had its chance
  var DEGRADE_AT = 45; // ~4.5s — cards become a usable scroller
  var LOAD_WITH_JQUERY_AT = 70; // ~7s  — bring our own jQuery too
  var LAST_ATTEMPT_AT = 150; // ~15s
  var GIVE_UP_AFTER = 300; // ~30s

  (function poll(tries) {
    if (hasSlick()) {
      cb();
      return;
    }
    if (tries === LOAD_AT || tries === LOAD_WITH_JQUERY_AT || tries === LAST_ATTEMPT_AT) {
      ensureSlick(tries !== LOAD_AT, function (ok) {
        if (!ok && tries === LAST_ATTEMPT_AT) {
          console.warn(
            "[shoppable-video] could not load slick from the theme assets.",
          );
        }
      });
    }
    if (tries === DEGRADE_AT && onDegrade) onDegrade();
    if (tries > GIVE_UP_AFTER) {
      console.warn(
        "[shoppable-video] slick never loaded; staying on scroll fallback.",
      );
      return;
    }
    setTimeout(function () {
      poll(tries + 1);
    }, 100);
  })(0);
}

function bootShoppableSliders(scope) {
  whenSlickReady(
    function () {
      initShoppableSlidersIn(scope);
    },
    function () {
      var root = scope && scope.querySelectorAll ? scope : document;
      root
        .querySelectorAll(".Shoppable-video-slider")
        .forEach(markShoppableFallback);
    },
  );
}

// Shopify theme editor: re-init when the section is (re)rendered, and tear down
// the Slick instance when it is removed so it can re-init cleanly.
document.addEventListener("shopify:section:load", function (e) {
  bootShoppableSliders(e.target);
});
document.addEventListener("shopify:section:unload", function (e) {
  if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
  jQuery(e.target)
    .find(".Shoppable-video-slider.slick-initialized")
    .each(function () {
      try {
        jQuery(this).slick("unslick");
      } catch (err) {}
    });
});

// Boot the carousel independently of every other widget in this file. custom.js
// is deferred, so the DOM is already parsed by the time this runs.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    bootShoppableSliders();
  });
} else {
  bootShoppableSliders();
}

// ── Header "Get App" button ───────────────────────────────────────────────────
// snippets/header-get-app.liquid renders one link per breakpoint with the store
// listings in data-* attributes and the Play Store link (or the App Store link,
// if that is the only one set) as the no-JS href. This block rewrites that href
// to the listing that matches the device, so Android goes to the Play Store and
// iPhone/iPad to the App Store.
//
// It lives here, in custom.js, rather than in theme.js (non-editable, and it is
// the compiled Impact bundle) and rather than inline in the section: custom.js
// is already loaded with `defer` in layout/theme.liquid, so this costs no extra
// request and never blocks the parser. No jQuery — it must run on its own.
(function () {
  "use strict";

  var SELECTOR = "a[data-get-app]";

  function storeUrlFor(link) {
    var android = link.getAttribute("data-play-store-url") || "";
    var ios = link.getAttribute("data-app-store-url") || "";
    var ua = navigator.userAgent || "";

    // iPadOS 13+ reports itself as "Macintosh"; maxTouchPoints is what separates
    // an iPad from a desktop Mac.
    var isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);

    if (/Android/i.test(ua)) return android || ios;
    if (isIOS) return ios || android;

    // Desktop. There is no handoff to a native store app here, just the store's
    // web listing, so we pick by the phone the visitor most likely carries: a Mac
    // visitor gets the App Store, everything else (Windows, Linux, ChromeOS) the
    // Play Store. Real iPads never reach this line — they are caught above.
    if (/Macintosh|Mac OS X/.test(ua)) return ios || android;
    return android || ios;
  }

  function resolveGetAppLinks(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll(SELECTOR).forEach(function (link) {
      var url = storeUrlFor(link);
      if (url) link.href = url;
    });
  }

  resolveGetAppLinks(document);

  // The header is re-rendered by the theme editor, and its icon row is rewritten
  // at runtime by the Kwikpass script, so re-resolve on section load and, as a
  // last resort, on the click itself (capture, before the browser navigates).
  document.addEventListener("shopify:section:load", function (event) {
    resolveGetAppLinks(event.target);
  });

  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest && event.target.closest(SELECTOR);
      if (!link) return;

      var url = storeUrlFor(link);
      if (url) link.href = url;
    },
    true,
  );
})();
